export default __webpack_public_path__ + "static/media/glasses.277b418a.svg";